<!--

RoadControls
------------

-->

<template>
    <div class="controls pt-3">
        <div class="form">
            <div class="form-group row">
                <div class="col">
                    <h3 class="mb-0">A Roads!</h3>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label">Show the A</label>
                </div>
                <div class="col-4">
                    <input type="number" class="form-control mr-1" v-model="number" min="1" max="9999">
                </div>
                <div class="col-4 d-flex">
                    <button class="btn btn-primary d-flex align-items-center"
                        @click="renderARoad"
                        :disabled="working">
                        <span v-if="!working">Go</span>
                        <b-spinner small v-if="working"></b-spinner>
                    </button>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-7">Show background map</label>
                <div class="col-5">
                    <b-form-checkbox switch size="lg" v-model="showMap"></b-form-checkbox>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-3">
                    <div @click="expand" class="text-primary text-link">
                        {{toggleText}}
                        &nbsp;
                        <b-icon icon="triangle-fill" :rotate="expanded ? 0 : 180"></b-icon>
                    </div>
                </div>
            </div>

            <b-collapse id="collapse-1" class="mt-2" v-model="expanded">
                <div class="form-group">
                    <div class="row">
                        <div class="col-3">
                            <label class="col-form-label">Range</label>
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control mr-1" v-model="range">
                        </div>
                        <div class="col-3 d-flex">
                            <button class="btn btn-primary d-flex align-items-center" @click="renderRange">
                                <span v-if="!working">Go</span>
                                <b-spinner small v-if="working"></b-spinner>
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <small class="form-text text-muted">
                                Enter a range, eg 1,2,5-7 to view the A1, A2, A5, A6 and A7.
                            </small>
                        </div>
                    </div>
                </div>
            </b-collapse>

        </div>
    </div>
</template>

<style lang="scss" scoped>
    .controls {
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 0px;
        width: 300px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .col, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9 {
        padding-left: 5px;
        padding-right: 5px;
    }

    .form {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>

<script>
    import { BFormCheckbox, BIcon, BCollapse, BSpinner } from 'bootstrap-vue'
    import { parseRange } from '../../modules/utils.js'
    import * as Errors from '../../modules/errors.js'
    import {mapMutations} from 'vuex'

    export default {
        components: {
            'b-form-checkbox': BFormCheckbox,
            'b-icon': BIcon,
            'b-collapse': BCollapse,
            'b-spinner': BSpinner
        },
        data: function() {
            return {
                number: '',
                range: '',
                showMap: true,
                expanded: false,
            }
        },
        methods: {
            renderARoad: function() {
                this.setWorking(true)
                if (this.number < 1 || this.number > 9999) {
                    Errors.invalidARoad()
                    this.setWorking(false)
                    return
                }
                const roadNumber = parseInt(this.number)
                this.$emit('render-road', roadNumber)
            },
            renderRange: function() {
                this.setWorking(true)
                if (this.range.match(/^[0-9,-]+$/g)) {
                    let p = parseRange(this.range)
                    this.$emit('render-range', p)
                }
                else {
                    Errors.incorrectRange()
                    this.setWorking(false)
                }
            },
            expand: function() {
                this.expanded = !this.expanded
            },
            ...mapMutations('map', ['setWorking'])
        },
        computed: {
            toggleText() {
                return this.expanded ? "Less" : "More"
            },
            working() {
                return this.$store.state.map.working
            }
        },
        watch: {
            showMap: function(newVal) {
                this.$emit('show-map', newVal)
            }
        }
    }
</script>